import { IMobileDevice } from '@apis/mobile-devices/mobileDevicesApiModel';
import { IUserInfo } from '@apis/team-management/teamManagementApiModel';

export enum DEVICE_SETTINGS_ACTIONS {
  REQUEST_MOBILE_DEVICES = 'DEVICE_SETTINGS/REQUEST_MOBILE_DEVICES',
  RECEIVE_MOBILE_DEVICES_SUCCEEDED = 'DEVICE_SETTINGS/RECEIVE_MOBILE_DEVICES_SUCCEEDED',
  RECEIVE_MOBILE_DEVICES_FAILED = 'DEVICE_SETTINGS/RECEIVE_MOBILE_DEVICES_FAILED',

  MOBILE_DEVICE_REMOVED = 'DEVICE_SETTINGS/MOBILE_DEVICE_REMOVED',

  REQUEST_RENAME_DEVICE = 'DEVICE_SETTINGS/REQUEST_RENAME_DEVICE',
  RECEIVE_RENAME_DEVICE_SUCCEEDED = 'DEVICE_SETTINGS/RECEIVE_RENAME_DEVICE_SUCCEEDED',
  RECEIVE_RENAME_DEVICE_FAILED = 'DEVICE_SETTINGS/RECEIVE_RENAME_DEVICE_FAILED',
}

export interface IMobileDeviceWithUser extends IMobileDevice {
  user?: IUserInfo;
}

export interface IDeviceSettingsState {
  mobileDevices: IMobileDeviceWithUser[];
  flags: {
    isFetchingMobileDevices: boolean;
    isUpdatingDeviceName: boolean;
  };
}
